import React, { useState } from "react";
import Input from "../../../common/input";

export default function DialogBox({ isOpen, onClose, handleAddNewCategory }) {
  const [formData, setFormData] = useState({
    name: "",
    is_top_collection: false,
    order: "",
  });

  const closeDialog = () => onClose();

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    // Prevent number at the start for the 'name' field
    if (name === "name" && value.length === 1 && /\d/.test(value[0])) {
      return; // Skip updating the state if the first character is a number
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddNewCategory(formData, closeDialog);
  };

  return (
    <>
      {isOpen && (
        <div className="relative z-50">
          <div
            className="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-[30px] transition-opacity"
            aria-hidden="true"
          ></div>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <div className="relative transform overflow-hidden rounded-lg bg-white text-left transition-all sm:my-8 sm:w-full sm:max-w-[800px]">
                <form onSubmit={handleSubmit}>
                  <div className="p-[24px]">
                    <h2 className="mb-[20px] text-left font-outfit text-[20px] font-medium leading-[25.2px] text-[#222222]">
                      Create New
                    </h2>
                    <div className="mb-[40px] grid grid-flow-row grid-cols-2 gap-x-[40px] gap-y-[20px]">
                      <Input
                        label="Category Name"
                        value={formData.name}
                        onChange={handleChange}
                        name="name"
                        type="text"
                        required
                        width="w-[356px]"
                      />

                      <Input
                        label="Category Order"
                        value={formData.order}
                        onChange={(e) => {
                          const newValue = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                          setFormData((prev) => ({
                            ...prev,
                            order: newValue,
                          }));
                        }}
                        name="order"
                        type="text"
                        width="w-[356px]"
                        required
                      />
                      <Input
                        label="Top Collection"
                        checked={formData.is_top_collection}
                        onChange={handleChange}
                        name="is_top_collection"
                        type="checkbox"
                        width="w-[20px]"
                      />
                    </div>

                    <div className="flex flex-row justify-end gap-[30px] px-6">
                      <button
                        type="button"
                        className="rounded-[10px] bg-[#F5F5F5] px-[46px] py-[12px] text-center font-outfit text-[16px] font-medium leading-[20.16px] text-[#222222]"
                        onClick={closeDialog}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="rounded-[10px] bg-[#0075FF] px-[46px] py-[12px] text-center font-outfit text-[16px] font-medium leading-[20.16px] text-white"
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
